<template>
  <v-list single-line class="py-0">
    <template v-for="(item, i) in instances.slice().reverse()">
      <span :key="i">
        <InstanceLeftMenuAction
            :currentInstance="current_instance"
            :item="item"
            v-if="item.router"
        />
      </span>
    </template>
  </v-list>
</template>

<script>
import InstanceLeftMenuAction from "@/modules/menus/left_menu/InstanceLeftMenuAction";

export default {
  name: "InstanceLeftMenu",
  components: {
    InstanceLeftMenuAction
  },
  props: {
    instances: {
      required: true,
      type: Array
    },
    current_instance: {
      required: true
    }
  }
}
</script>

<style scoped>

</style>
